import './App.css';
import { Box } from '@mui/material';
import Board from './Components/Board';
import { Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import Notifications from './Notifications';
import Chat from './Components/Chat';
import { useDispatch } from 'react-redux';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { appendMessage, setAnalyticsInstance, setConnected, setGame, setMessages, setPresence } from './services/GameSlice';
import { setBody, setType } from './services/NotificationSlice';
import { setPeerConnections } from './services/PeerConnectionsSlice';
import { getSocket } from './socket';
import ContentLayout from './Components/Layout/ContentLayout';
import HowToPlay from './Components/Pages/HowToPlay';
import Strategy from './Components/Pages/Strategy';
import About from './Components/Pages/About';
import FAQ from './Components/Pages/FAQ';
import PrivacyPolicy from './Components/Pages/PrivacyPolicy';
import TermsOfService from './Components/Pages/TermsOfService';
import Contact from './Components/Pages/Contact';

function App() {
  const dispatch = useDispatch();

  const firebaseConfig = {
    apiKey: "AIzaSyDxbgKv9nThMpKYIzv9U7R-JQAXFAUAftA",
    authDomain: "play-sequence.firebaseapp.com",
    projectId: "play-sequence",
    storageBucket: "play-sequence.appspot.com",
    messagingSenderId: "154367757387",
    appId: "1:154367757387:web:185111808b8235ec9091ce",
    measurementId: "G-0JSK5D2DNH"
  };

  useEffect(() => {
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    dispatch(setAnalyticsInstance(analytics));
    // eslint-disable-next-line
  }, [dispatch])

  // Single place where server pushes are turned into store updates. Mounted
  // once for the whole app so listeners are never registered twice.
  useEffect(() => {
    const socket = getSocket();

    const onConnect = () => dispatch(setConnected(true));
    const onDisconnect = () => dispatch(setConnected(false));
    const onGameUpdate = (game) => dispatch(setGame(game));
    const onPresence = (presence) => dispatch(setPresence(presence));
    const onChatHistory = (messages) => dispatch(setMessages(messages));
    const onChatMessage = (message) => dispatch(appendMessage(message));
    const onPeerUpdate = (connections) => dispatch(setPeerConnections(connections));
    const onError = (error) => {
      dispatch(setType('error'));
      dispatch(setBody(error?.message || 'Something went wrong'));
    };

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('game:update', onGameUpdate);
    socket.on('game:presence', onPresence);
    socket.on('chat:history', onChatHistory);
    socket.on('chat:message', onChatMessage);
    socket.on('peer:update', onPeerUpdate);
    socket.on('game:error', onError);

    if (socket.connected) {
      dispatch(setConnected(true));
    }

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('game:update', onGameUpdate);
      socket.off('game:presence', onPresence);
      socket.off('chat:history', onChatHistory);
      socket.off('chat:message', onChatMessage);
      socket.off('peer:update', onPeerUpdate);
      socket.off('game:error', onError);
    };
  }, [dispatch])

  return (
    <Box>
      <Notifications />
      <Routes>
        <Route path='/' element={<><Chat /><Board /></>} />
        <Route path='/:gameId' element={<><Chat /><Board /></>} />
        <Route element={<ContentLayout />}>
          <Route path='/how-to-play' element={<HowToPlay />} />
          <Route path='/strategy' element={<Strategy />} />
          <Route path='/about' element={<About />} />
          <Route path='/faq' element={<FAQ />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms' element={<TermsOfService />} />
          <Route path='/contact' element={<Contact />} />
        </Route>
      </Routes>
    </Box>
  );
}

export default App;
